import { Box, Typography } from '@mui/material';
import AddProductCard from 'components/shared/CustomDashboard/KeyDealsTab/DealFormField/AddProductCard';
import { Product } from 'model/deals.model';
import { useEffect, useMemo, useState } from 'react';
import { DealsService } from 'service/deals.service';
import zeplinColor from 'theme/Color';

const getProductId = (p: any) => p?.PricebookEntryId || p?.id;
const getProductName = (p: any) => p?.ProductName || p?.name;

const DealsAddProductFormField = ({
  handleInputChange,
  value,
  opportunityId,
}: {
  handleInputChange: (field: string, value: any, index?: number) => void;
  opportunityId: string;
  value: any;
}) => {
  const [originalProducts, setOriginalProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const getPricebookProducts = async (pricebookId: string) => {
    try {
      setLoading(true);
      if (!pricebookId || pricebookId === 'none') return;

      const res = await DealsService.getPricebookProducts(pricebookId);
      const productsList = res.products;
      setOriginalProducts(productsList);

      if (!value?.products || value.products.length === 0) {
        const productEntries = productsList.map((product: Product) => ({
          OpportunityId: opportunityId || '',
          PricebookEntryId: product?.PricebookEntryId || product?.id,
          Quantity: '',
          UnitPrice: product?.UnitPrice,
        }));
        handleInputChange('products', productEntries);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const pricebookId = value?.pricebookId || value;

    if (pricebookId && pricebookId !== 'none') {
      getPricebookProducts(pricebookId);
    }
  }, [value?.pricebookId]);

  const enrichedProducts = useMemo(() => {
    const formProducts = value?.products || [];

    return formProducts.map((product: Product) => {
      const original = originalProducts.find((p) => getProductId(p) === getProductId(product));

      return {
        ...original,
        ...product,
        name: getProductName(original) || getProductName(product),
      };
    });
  }, [value?.products, originalProducts]);

  if (loading) return <>Loading Products...</>;

  return (
    <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
        <Typography variant='heading4'>Add Products</Typography>
        <Typography variant='body2' color={zeplinColor.Neutral9}>
          Price book:
        </Typography>

        {enrichedProducts.map((product: Product, index: number) => (
          <AddProductCard
            key={getProductId(product)}
            data={product}
            index={index}
            handleInputChange={handleInputChange}
          />
        ))}
      </Box>
    </Box>
  );
};

export default DealsAddProductFormField;
